//@flow
import React, {useState} from 'react';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import {Typography, Divider, makeStyles} from '@material-ui/core';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import CustomTextField from '../../../../elements/CustomTextField/CustomTextField';
import {useContactActions} from '../utils/use-contact';
import InlineLoader from '../../../../elements/LoadingSpinner/InlineLoader';

type Props = {
  open: boolean,
  onClose: () => void,
  onSave: (name: string) => void,
  name: string,
  identifier: string,
};

const useStyles = makeStyles(theme => ({
  modalPaper: {
    width: '100%',
    maxWidth: 500,
    padding: '1rem',
    borderRadius: '1rem',
  },
  root: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: '1rem',
    minWidth: 300,
    position: 'relative',
  },
  loader: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    zIndex: 1,
    backgroundColor: 'rgba(255,255,255,.5)',
  },
  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 600,
    textAlign: 'center',
  },
  filterList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.5rem',
  },
  footer: {
    display: 'flex',
    gap: '.5rem',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.5rem',
  },
}));

export default function EditContactModal(props: Props) {
  const {open, onClose, onSave, name: prevName, identifier} = props;

  const classes = useStyles();

  const [name, setName] = useState(prevName);

  const {updateName, loading} = useContactActions();

  const handleSave = () => {
    updateName(identifier, name).then(success => {
      if (success) {
        onClose();
        onSave(name);
      }
    });
  };

  return (
    <CustomModal
      open={open}
      handleCloseModal={onClose}
      classes={{
        paper: classes.modalPaper,
      }}
    >
      <aside className={classes.root}>
        {loading && (
          <div className={classes.loader}>
            <InlineLoader size={45} />
          </div>
        )}
        <header className={classes.header}>
          <Typography className={classes.title}>Filtros</Typography>
        </header>

        <div className={classes.content}>
          <Divider className={classes.divider} />
          <CustomTextField
            label="Nombre"
            value={name}
            onChange={e => setName(e.target.value)}
            fullWidth
          />
        </div>

        <footer className={classes.footer}>
          <CustomButton
            variant="contained"
            color="primary"
            onClick={handleSave}
            fullWidth
            disabled={loading}
          >
            Guardar
          </CustomButton>
        </footer>
      </aside>
    </CustomModal>
  );
}
